import React, { useState } from 'react';
import Button from '../components/Button';
import loginImage from '../assets/images/login.svg';
import logo from '../assets/images/logo.svg';
import '../styles/login.css';
import { loginUser } from '../api/api';
import { useDispatch } from 'react-redux';
import { loginSuccess } from '../features/auth/AuthSlice';
import { useNavigate } from 'react-router-dom';
import Toastmessage from '../components/Toast';

const Login = () => {

  // State management
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({email:'', password:''});
  const [isLoading, setIsloading] = useState(false); 
  const dispatch = useDispatch();
  const navigate = useNavigate();


  // Validation email and password
  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
  }

  const validatePassword = (password) => {
    return password.length >= 5;
  }


  const loginValidate = async () => {
    let emailError = '';
    let passwordError = '';

    if (!validateEmail(email)) {
      emailError = 'Please enter a valid email address.';
    }

    if (!validatePassword(password)) {
      passwordError = 'Password must be at least 6 characters long.';
    }

    if (emailError || passwordError) {
      setErrors({ email: emailError, password: passwordError });
    } else {
      setErrors({ email: '', password: '' });
      setIsloading(true); // Start loading

      // Simulate an API call
      try {
        //login API call
        const data = await loginUser(email, password);
        const token = data.user_details.auth_token;
        const id = data.user_details.id;
        const useremail = data.user_details.email
        const name = data.user_details.name

        dispatch(loginSuccess({token, id,useremail,name}));
        const toast = await Toastmessage(data.message, true)
        
        // Reset the fields after the login process
        setEmail('');
        setPassword('');
        navigate('/home');
      } catch (error) {
        const toast = await Toastmessage('Login failed! Please check your credentials.', false)
      } finally {
        setIsloading(false); // End loading
      }
    }
  };

  return (
    <div>
      <div className="content">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 d-none d-md-block">
              <img src={loginImage} alt="Image" className="img-fluid p-3" />
            </div>
            <div className="col-md-6 contents">
              <div className="row justify-content-center">
                <div className="col-md-9">
                  <div className="mb-4">
                    <img src={logo} alt="company logo" className='img-fluid p-3 d-block mx-auto'/>
                    <h3>Sign In</h3>
                  
                  </div>
                  <div>
                    <div className={`form-group first ${email ? 'field--not-empty' : ''}`}>
                      <label htmlFor="email">Email ID</label>
                      <input 
                        type="email" 
                        className="form-control" 
                        id="email" 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)} // Update state on input
                      />
                    </div>
                    {errors.email && <div className="text-danger small">{errors.email}</div>}
                    <div className={`form-group last mt-4 ${password ? 'field--not-empty' : ''}`}>
                      <label htmlFor="password">Password</label>
                      <input 
                        type="password" 
                        className="form-control" 
                        id="password" 
                        value={password}
                        onChange={(e) => setPassword(e.target.value)} // Update state on input
                      />
                    </div>
                    {errors.password && <div className='text-danger small'>{errors.password}</div>}
                    <Button 
                      label="Login" 
                      onClick={loginValidate}  
                      customClass='btn-button-padding btn-block btn-theme-button mt-4 mb-3' 
                      disabled={isLoading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
